import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DriversService } from '../root/drivers.service';
import { HSEScore } from '../types';

@Pipe({
  name: 'hseScoreFromId',
})
export class HseScoreFromIdPipe implements PipeTransform {
  constructor(private driverService: DriversService) {}

  // tslint:disable-next-line
  public transform(value: string, ...args: unknown[]): Observable<HSEScore | null> {
    return this.driverService.driverSafetyScores$.pipe(
      filter((s) => !!s),
      map((safety) => {
        if (value in safety) {
          return safety[value];
        }
        return null;
      }),
    );
  }
}
